import React from 'react';
import { Menu, Image } from 'semantic-ui-react';
import { NavLink, Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import UserAppHeaderDropdown from './dropdowns/UserAppHeaderDropdown';
import MaintenanceAppHeaderDropdown from './dropdowns/MaintenanceAppHeaderDropdown';
import store from '../store/store';

class AppHeader extends React.Component {
  render = () => {
    const currStore = store.getState();
    const filters = currStore.filters || {};
    const authorized = currStore.authorization.role !== 'transfer_claims';
    return (
      <Menu stackable size="tiny" className="c-AppHeader">
        <Menu.Item header as={Link} to="/">
          <Image src={logo} width="70" />
        </Menu.Item>
        <Menu.Menu position="right">
          {authorized && (
            <Menu.Item
              name="tasks manager"
              as={NavLink}
              to={`/manager-tasks${
                '?' + (filters['manager-tasks'] ? filters['manager-tasks'] : '')
              }`}
            />
          )}
          {authorized && (
            <Menu.Item
              name="tasks"
              as={NavLink}
              to={`/${'?' + (filters.tasks ? filters.tasks : '')}`}
              exact
            />
          )}
          <Menu.Item
            name="claims"
            as={NavLink}
            to={`/claims${'?' + (filters.claims ? filters.claims : '')}`}
          />
          <Menu.Item
            name="tickets"
            as={NavLink}
            to={`/tickets${'?' + (filters.tickets ? filters.tickets : '')}`}
          />
          {authorized && <MaintenanceAppHeaderDropdown />}
          <UserAppHeaderDropdown />
        </Menu.Menu>
      </Menu>
    );
  };
}

export default withRouter(AppHeader);



// WEBPACK FOOTER //
// ./src/component/AppHeader.js